import {
  x_up_default
} from "./chunk-NFV4YPJT.js";

// src/layouts/x-up/index.ts
var x_up_default2 = x_up_default;

export {
  x_up_default2 as x_up_default
};
